import * as React from "react";
const SvgRuler = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m36.344 42 2.121 2.122m.707-4.95 2.121 2.12M42 36.344l2.122 2.122m-9.052 4.807 8.202-8.203c.792-.792 1.188-1.188 1.645-1.336a2 2 0 0 1 1.236 0c.456.148.852.544 1.643 1.335L48.93 36.2c.792.792 1.188 1.19 1.337 1.646.13.402.13.834 0 1.235-.149.457-.545.853-1.337 1.645l-8.202 8.203c-.792.792-1.189 1.188-1.645 1.336-.402.13-.834.13-1.235 0-.457-.148-.854-.544-1.646-1.336l-1.133-1.133c-.79-.791-1.187-1.187-1.335-1.643a2 2 0 0 1 0-1.236c.148-.457.545-.853 1.337-1.645"
    />
  </svg>
);
export default SvgRuler;
